import React, { useEffect, useMemo, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AsyncPaginate } from "react-select-async-paginate";
import MasterService from "../../../../services/master/MasterService";
import UserService from "../../../../services/user/UserService";
import TransaksiService from "../../../../services/transaksi/TransaksiService";
import { formatDateString, getCurrentDateFormatted, romanNum } from "../../../../utilities/Utils";
import { FaChevronLeft, FaSave } from "react-icons/fa";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import { Spinner } from "react-bootstrap";

const ViewHeader = ({ dataHeader, cancelHeader, saveHeader }) => {
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    let masterService = useMemo(() => new MasterService(), [])
    let userService = useMemo(() => new UserService(), [])
    let transaksiService = useMemo(() => new TransaksiService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(false)
    const handleShowConfirmSave = () => {
        setShowConfirmSave(true)
    }

    const [showSaveSuccess, setShowSaveSucces] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)

    const [valueJenisKomoditiOpt, setValueJenisKomoditiOpt] = useState(null)
    const [valueMaksudPengirimanOpt, setValueMaksudPengirimanOpt] = useState(null)
    const [valuePeruntukanOpt, setValuePeruntukanOpt] = useState(null);
    const [valueUptOpt, setValueUptOpt] = useState(null)

    const [valueTraderOpt, setValueTraderOpt] = useState(null)
    const [keyForSecondSelect, setKeyForSecondSelect] = useState(0);
    const [valueTraderAlamatOpt, setValueTraderAlamatOpt] = useState(null)

    const [valuePelAsalOpt, setValuePelAsalOpt] = useState(null)
    const [valuePelDnOpt, setValuePelDnOpt] = useState(null)
    const [valuePelLnOpt, setValuePelLnOpt] = useState(null)
    const [valueCaraAngkutOpt, setValueCaraAngkutOpt] = useState(null)
    const [valueNmAngkut, setValueNmAngkut] = useState(null)
    const [valueNoVoyFlight, setValueNoVoyFlight] = useState(null)
    const [valueBenderaOpt, setValueBenderaOpt] = useState(null)
    const [valueTglEkspor, setValueTglEkspor] = useState(getCurrentDateFormatted())
    const [valueNilaiEkspor, setValueNilaiEkspor] = useState(null)
    const [valueNetto, setValueNetto] = useState(null)
    const [valueBruto, setValueBruto] = useState(null)
    const [valuePartnerOpt, setValuePartnerOpt] = useState(null)

    const [valueNamaCp, setValueNamaCp] = useState(null)
    const [valueAlamatCp, setValueAlamatCp] = useState(null)
    const [valueTelpCp, setValueTelpCp] = useState(null)

    const [valueNamaTtd, setValueNamaTtd] = useState(null)
    const [valueJabatanTtd, setValueJabatanTtd] = useState(null)
    const [valueTempatTtd, setValueTempatTtd] = useState(null)
    const [valueTanggalTtd, setValueTanggalTtd] = useState(getCurrentDateFormatted())

    useEffect(() => {
        if (!dataHeader) return

        const fetchAllOptions = async () => {
            try {
                // console.log(dataHeader.peruntukan)
                const resJenisKomoditi = await masterService.getJenisKomoditiById(dataHeader.jenisKomoditi)
                if (resJenisKomoditi) {
                    setValueJenisKomoditiOpt(resJenisKomoditi.data)

                    const resMaksud = await masterService.getMaksudPengirimanById(dataHeader.maksudKegiatan)
                    setValueMaksudPengirimanOpt(resMaksud.data)

                    const resUpt = await userService.getUptById(dataHeader.kdUpt)
                    setValueUptOpt(resUpt.data)

                    const optionPeruntukan = [{ value: '1', label: 'Konsumsi' }, { value: '2', label: 'Non Konsumsi' }]
                    setValuePeruntukanOpt(optionPeruntukan.find(option => option.value === dataHeader.peruntukan))

                    const resTrader = await userService.getTraderById(dataHeader.kodeTrader)
                    setValueTraderOpt(resTrader.data)

                    const resTraderAlamat = await userService.listTraderAlamat(dataHeader.kodeTrader, dataHeader.alamatTrader, 0, 10)
                    setValueTraderAlamatOpt(resTraderAlamat.data.data)

                    const resPartner = await userService.getPartnerById(dataHeader.idPartner)
                    setValuePartnerOpt(resPartner.data)

                    const jsonPelAsal = {
                        jnsPelabuhan: "D",
                        kodePelabuhan: dataHeader.pelabuhanAsal
                    }
                    const resPelAsal = await masterService.getPelabuhanById(JSON.stringify(jsonPelAsal))
                    setValuePelAsalOpt(resPelAsal.data)

                    const jsonPelDn = {
                        jnsPelabuhan: "D",
                        kodePelabuhan: dataHeader.pelabuhanMuat
                    }
                    const resPelDn = await masterService.getPelabuhanById(JSON.stringify(jsonPelDn))
                    setValuePelDnOpt(resPelDn.data)

                    const jsonPelLn = {
                        jnsPelabuhan: "L",
                        kodePelabuhan: dataHeader.pelabuhanBongkar
                    }
                    const resPelLn = await masterService.getPelabuhanById(JSON.stringify(jsonPelLn))
                    setValuePelLnOpt(resPelLn.data)

                    const resCaraAngkut = await masterService.getCaraAngkutById(dataHeader.moda)
                    setValueCaraAngkutOpt(resCaraAngkut.data)
                    setValueNmAngkut(dataHeader.angkut)
                    setValueNoVoyFlight(dataHeader.voyage)
                    setValueTglEkspor(formatDateString(dataHeader.tanggalTibaBerangkat))

                    const resBendera = await masterService.getNegaraById(dataHeader.bendera)
                    setValueBenderaOpt(resBendera.data)

                    setValueNilaiEkspor(dataHeader.nilai)
                    setValueBruto(dataHeader.bruto)
                    setValueNetto(dataHeader.netto)

                    setValueNamaCp(dataHeader.namaCp)
                    setValueAlamatCp(dataHeader.alamatCp)
                    setValueTelpCp(dataHeader.teleponCp)
                    setValueNamaTtd(dataHeader.namaTtd)
                    setValueJabatanTtd(dataHeader.jabatanTtd)
                    setValueTempatTtd(dataHeader.tempatTtd)
                    setValueTanggalTtd(dataHeader.tanggalTtd)

                }
            } catch (error) {
                // console.log(error)
            }
        }
        fetchAllOptions()
    }, [dataHeader, masterService, userService])

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const resUserSession = await userService.getUserById(localStorage.getItem("userId"))
                setValueNamaCp(resUserSession.data.nama)
                setValueAlamatCp(resUserSession.data.alamat)
                setValueTelpCp(resUserSession.data.telepon)
                setValueNamaTtd(resUserSession.data.nama)
                setValueJabatanTtd(resUserSession.data.jabatan)
            } catch (error) {
                // console.log(error)
            }
        }
        fetchUserData()
    }, [userService])

    async function loadOptionJenisKomoditi(search, loadedOption, { page = 1 }) {
        const response = await masterService.listJenisKomoditi(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionMaksudPengiriman(search, loadedOption, { page = 1 }) {
        const response = await masterService.listMaksudPengiriman(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionPeruntukan(search, loadedOption, { page }) {
        const options = [
            {
                value: '1',
                label: 'Konsumsi'
            },
            {
                value: '2',
                label: 'Non Konsumsi'
            }
        ]
        return {
            options: options,
        }
    }

    async function loadOptionUpt(search, loadedOption, { page = 1 }) {
        const response = await userService.listUpt(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionTrader(search, loadedOption, { page = 1 }) {
        let kodeTrader = localStorage.getItem('kodeTrader')
        let response;
        if (kodeTrader !== null) {
            let trader = await userService.getTraderById(kodeTrader)
            response = await userService.listTrader(trader.data.npwp, trader.data.nama, page - 1, 10)
        } else {
            response = await userService.listTrader(search, search, page - 1, 10)
        }
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionTraderAlamat(search, loadedOption, { page = 1 }) {
        let response = await userService.listTraderAlamat(valueTraderOpt.kodeTrader, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionPartner(search, loadedOption, { page = 1 }) {
        const response = await userService.listPartner(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionPartnerByTrader(search, loadedOption, { page = 1 }) {
        let kodeTrader = localStorage.getItem("kodeTrader")
        const response = await userService.listPartnerByTrader(kodeTrader, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionPelAsal(search, loadedOption, { page = 1 }) {
        const response = await masterService.listPelabuhan(search, 'D', search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionPelDn(search, loadedOption, { page = 1 }) {
        const response = await masterService.listPelabuhan(search, 'D', search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionPelLn(search, loadedOption, { page = 1 }) {
        const response = await masterService.listPelabuhan(search, 'L', search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionCaraAngkut(search, loadedOption, { page = 1 }) {
        const response = await masterService.listCaraAngkut(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionBendera(search, loadedOption, { page = 1 }) {
        const response = await masterService.listNegara(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangeJenisKomoditi = e => {
        setValueJenisKomoditiOpt(e)
    }

    const onChangeMaksudPengiriman = e => {
        setValueMaksudPengirimanOpt(e)
    }

    const onChangePeruntukan = e => {
        setValuePeruntukanOpt(e)
    }

    const onChangeUpt = e => {
        setValueUptOpt(e)
    }

    const onChangeTrader = e => {
        setKeyForSecondSelect(prevKey => prevKey + 1)
        setValueTraderOpt(e)
    }

    const onChangeTraderAlamat = e => {
        setValueTraderAlamatOpt(e)
    }

    const onChangePartner = e => {
        setValuePartnerOpt(e)
    }

    const onChangePelAsal = e => {
        setValuePelAsalOpt(e)
    }

    const onChangePelDn = e => {
        setValuePelDnOpt(e)
    }

    const onChangePelLn = e => {
        setValuePelLnOpt(e)
    }

    const onChangeCaraAngkut = e => {
        setValueCaraAngkutOpt(e)
    }

    const onChangeNmAngkut = e => {
        setValueNmAngkut(e.target.value)
    }

    const onChangeNoVoyFlight = e => {
        setValueNoVoyFlight(e.target.value)
    }

    const onChangeBendera = e => {
        setValueBenderaOpt(e)
    }

    const onChangeTglEkspor = e => {
        setValueTglEkspor(e.target.value)
    }

    const onChangeNilai = e => {
        setValueNilaiEkspor(e.target.value)
    }

    const onChangeNetto = e => {
        setValueNetto(e.target.value)
    }

    const onChangeBruto = e => {
        setValueBruto(e.target.value)
    }

    const onChangeNamaTtd = e => {
        setValueNamaTtd(e.target.value)
    }

    const onChangeJabatanTtd = e => {
        setValueJabatanTtd(e.target.value)
    }

    const onChangeTempatTtd = e => {
        setValueTempatTtd(e.target.value)
    }

    const onChangeTanggalTtd = e => {
        setValueTanggalTtd(e.target.value)
    }

    const handleClickSimpan = async () => {
        localStorage.removeItem('dataHeaderStorage')
        if (checkKelengkapan()) {

            let nomorAju
            let tanggalAju
            if (dataHeader === undefined || dataHeader === null || Object.keys(dataHeader).length === 0) {
                const respNomor = await pbumkuService.ambilNomorService('PPM_AJU', valueUptOpt.kdUnit, currentYear, localStorage.getItem('username'))
                nomorAju = respNomor.data.uraianPusat + respNomor.data.kodePusat + romanNum(currentMonth) + currentYear + respNomor.data.nomorUrut
                tanggalAju = new Date()
            } else {
                nomorAju = dataHeader.nomorAju
                tanggalAju = dataHeader.tanggalAju
            }

            let dataheader = {
                ...dataHeader,
                nomorAju: nomorAju,
                tanggalAju: tanggalAju,
                status: (dataHeader === undefined || dataHeader === null || Object.keys(dataHeader).length === 0) ? '000' : dataHeader.status,
                kdKegiatan: 'E',
                jenisKomoditi: valueJenisKomoditiOpt.id,
                maksudKegiatan: valueMaksudPengirimanOpt.kd,
                peruntukan: valuePeruntukanOpt.value,
                kdUpt: valueUptOpt.kdUnit,
                kodeTrader: valueTraderOpt.kodeTrader,
                npwpTrader: valueTraderOpt.npwp,
                namaTrader: valueTraderOpt.nama,
                alamatTrader: (valueTraderAlamatOpt.alamat === null || valueTraderAlamatOpt.alamat === undefined) ? valueTraderOpt.alamat : valueTraderAlamatOpt.alamat,
                kodeposTrader: (valueTraderAlamatOpt.kodepos === null || valueTraderAlamatOpt.kodepos === undefined) ? valueTraderOpt.kodepos : valueTraderAlamatOpt.kodepos,
                idPartner: valuePartnerOpt.idPartner,
                namaPartner: valuePartnerOpt.nama,
                alamatPartner: valuePartnerOpt.alamat,
                negaraPartner: valuePartnerOpt.negara,
                pelabuhanAsal: valuePelAsalOpt.tbRPelabuhanPK.kodePelabuhan,
                pelabuhanMuat: valuePelDnOpt.tbRPelabuhanPK.kodePelabuhan,
                pelabuhanBongkar: valuePelLnOpt.tbRPelabuhanPK.kodePelabuhan,
                moda: valueCaraAngkutOpt.id,
                angkut: valueNmAngkut,
                voyage: valueNoVoyFlight,
                bendera: valueBenderaOpt.kodeNegara,
                tanggalTibaBerangkat: valueTglEkspor,
                nilai: valueNilaiEkspor,
                netto: valueNetto,
                bruto: valueBruto,
                namaCp: valueNamaCp,
                alamatCp: valueAlamatCp,
                teleponCp: valueTelpCp,
                namaTtd: valueNamaTtd,
                jabatanTtd: valueJabatanTtd,
                tempatTtd: valueTempatTtd,
                tanggalTtd: valueTanggalTtd,
                dateCreated: new Date(),
                userCreated: localStorage.getItem('username').substring(0, 5),
                synch: '0'
            }

            try {
                setLoadingSave(true)
                const response = await transaksiService.addPpm(JSON.stringify(dataheader))
                if (response.data.kode === '200') {
                    setShowSaveSucces(true)
                    setShowConfirmSave(false)
                    localStorage.setItem('dataHeaderStorage', JSON.stringify(dataheader))
                    localStorage.setItem('nomorAjuStorage', nomorAju)

                    let dataStatus = {
                        nomorAju: nomorAju,
                        kodeStatus: '000',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem('username')
                    }
                    await transaksiService.addPpmStatus(JSON.stringify(dataStatus))
                }
                setLoadingSave(false)
            } catch (error) {
                setShowConfirmSave(false)
                setShowSaveFailed(true)
                setLoadingSave(false)
            }
        } else {
            setShowConfirmSave(false)
            setShowSaveFailed(true)
        }
    }

    const handleClickSaveSuccess = () => {
        setLoadingSave(false)
        setShowSaveSucces(false)
        saveHeader('komoditi')
    }

    const handleClickSaveFailed = () => {
        setLoadingSave(false)
        setShowSaveFailed(false)
    }

    const [kelengkapan, setKelengkapan] = useState({})

    const checkKelengkapan = () => {
        const checkKelengkapan = {}
        if (!valueJenisKomoditiOpt) checkKelengkapan.jenisKomoditi = 'Jenis Komoditi Wajib Diisi'
        if (!valueMaksudPengirimanOpt) checkKelengkapan.maksudPengiriman = 'Maksud Pengiriman Wajib Diisi'
        if (!valuePeruntukanOpt) checkKelengkapan.peruntukan = 'Peruntukan Wajib Diisi'
        if (!valueUptOpt) checkKelengkapan.upt = 'UPT Wajib Diisi'
        if (!valuePelAsalOpt) checkKelengkapan.pelAsal = 'Pelabuhan Asal Wajib Diisi'
        if (!valuePelDnOpt) checkKelengkapan.pelMuat = 'Pelabuhan Muat Wajib Diisi'
        if (!valuePelLnOpt) checkKelengkapan.pelTujuan = 'Pelabuhan Tujuan/Ekspor Wajib Diisi'
        if (!valueTraderOpt) checkKelengkapan.pengirim = 'Pengirim Wajib Diisi'
        if (!valueTraderAlamatOpt) checkKelengkapan.alamat = 'Alamat Pengirim Wajib Diisi'
        if (!valuePartnerOpt) checkKelengkapan.partner = 'Penerima Wajib Diisi'
        if (!valueCaraAngkutOpt) checkKelengkapan.caraAngkut = 'Cara Angkut Wajib Diisi'
        if (!valueNmAngkut) checkKelengkapan.nmAngkut = 'Nama Angkut Wajib Diisi'
        if (!valueNoVoyFlight) checkKelengkapan.noVoyFlight = 'Nomor Voyage/Flight Wajib Diisi'
        if (!valueBenderaOpt) checkKelengkapan.bendera = 'Bendera Wajib Diisi'
        if (!valueTglEkspor) checkKelengkapan.tglEkspor = 'Tanggal Ekspor Wajib Diisi'
        if (!valueNilaiEkspor) checkKelengkapan.nilaiEkspor = 'Nilai Ekspor Wajib Diisi'
        if (!valueNetto) checkKelengkapan.netto = 'Netto Wajib Diisi'
        if (!valueBruto) checkKelengkapan.bruto = 'Bruto Wajib Diisi'
        if (!valueTempatTtd) checkKelengkapan.tempatTtd = 'Tempat Penandatangan Wajib Diisi'

        setKelengkapan(checkKelengkapan)
        return Object.keys(checkKelengkapan).length === 0
    }


    return (
        <>
            <div className="form-card text-start">
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Pengajuan : {localStorage.getItem('nomorAjuStorage')} </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Jenis Komoditi<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionJenisKomoditi}
                                        value={valueJenisKomoditiOpt}
                                        getOptionValue={(option) => option.id}
                                        getOptionLabel={(option) => option.jenisKomoditi}
                                        additional={{
                                            page: 1,
                                        }}
                                        onChange={onChangeJenisKomoditi}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.jenisKomoditi && <div className="text-danger">{kelengkapan.jenisKomoditi}</div>}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Maksud Kegiatan<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionMaksudPengiriman}
                                        value={valueMaksudPengirimanOpt}
                                        getOptionValue={(option) => option.kd}
                                        getOptionLabel={(option) => option.maksudPengiriman}
                                        additional={{
                                            page: 1,
                                        }}
                                        onChange={onChangeMaksudPengiriman}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.maksudPengiriman && <div className="text-danger">{kelengkapan.maksudPengiriman}</div>}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Peruntukan<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionPeruntukan}
                                        value={valuePeruntukanOpt}
                                        getOptionValue={(option) => option.value}
                                        getOptionLabel={(option) => option.label}
                                        additional={{
                                            page: 0,
                                        }}
                                        onChange={onChangePeruntukan}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.peruntukan && <div className="text-danger">{kelengkapan.peruntukan}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">UPT<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionUpt}
                                        value={valueUptOpt}
                                        getOptionValue={(option) => option.kdUnit}
                                        getOptionLabel={(option) => option.nmPendekBaru +  ' d/h ' + option.nmUnit}
                                        additional={{
                                            page: 1,
                                        }}
                                        onChange={onChangeUpt}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.upt && <div className="text-danger">{kelengkapan.upt}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Pelabuhan</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Pelabuhan Asal<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionPelAsal}
                                        value={valuePelAsalOpt}
                                        getOptionValue={(option) => option.tbRPelabuhanPK.kodePelabuhan}
                                        getOptionLabel={(option) => option.tbRPelabuhanPK.kodePelabuhan + '-' + option.uraianPelabuhan}
                                        additional={{
                                            page: 1,
                                        }}
                                        onChange={onChangePelAsal}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.pelAsal && <div className="text-danger">{kelengkapan.pelAsal}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Pelabuhan Muat Ekspor<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionPelDn}
                                        value={valuePelDnOpt}
                                        getOptionValue={(option) => option.tbRPelabuhanPK.kodePelabuhan}
                                        getOptionLabel={(option) => option.tbRPelabuhanPK.kodePelabuhan + '-' + option.uraianPelabuhan}
                                        additional={{
                                            page: 1,
                                        }}
                                        onChange={onChangePelDn}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.pelMuat && <div className="text-danger">{kelengkapan.pelMuat}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Pelabuhan Tujuan/Bongkar Ekspor<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionPelLn}
                                        value={valuePelLnOpt}
                                        getOptionValue={(option) => option.tbRPelabuhanPK.kodePelabuhan}
                                        getOptionLabel={(option) => option.tbRPelabuhanPK.kodePelabuhan + '-' + option.uraianPelabuhan}
                                        additional={{
                                            page: 1,
                                        }}
                                        onChange={onChangePelLn}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.pelTujuan && <div className="text-danger">{kelengkapan.pelTujuan}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Pengirim</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">NPWP</label>
                                    <input type="text" className="form-control-sm" name="npwp_eksportir" placeholder="NPWP Eksportir" value={valueTraderOpt !== null ? valueTraderOpt.npwp : ''} readOnly />
                                </div>
                            </div>
                            <div className="col-8">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nama<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionTrader}
                                        value={valueTraderOpt}
                                        getOptionValue={(option) => option.kodeTrader}
                                        getOptionLabel={(option) => option.kodeTrader + '-' + option.nama}
                                        additional={{
                                            page: 1,
                                        }}
                                        onChange={onChangeTrader}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.pengirim && <div className="text-danger">{kelengkapan.pengirim}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Pilih Alamat<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        key={keyForSecondSelect}
                                        loadOptions={loadOptionTraderAlamat}
                                        value={valueTraderAlamatOpt}
                                        getOptionLabel={(option) => option.alamat + ' - Kode Pos : ' + option.kodepos}
                                        getOptionValue={(option) => option.alamat}
                                        additional={{
                                            page: 1
                                        }}
                                        onChange={onChangeTraderAlamat}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.alamat && <div className="text-danger">{kelengkapan.alamat}</div>}
                                </div>
                            </div>
                        </div>
                        {/* <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Alamat</label>
                                    <textarea rows={3} className="form-control" name="alamat_eksportir" value={valueTraderOpt !== null ? valueTraderOpt.alamat : ''} readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Kode Pos</label>
                                    <input type="text" className="form-control-sm" name="kodepos_eksportir" placeholder="Kode Pos" value={valueTraderOpt !== null ? valueTraderOpt.kodepos : ''} readOnly />
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Sarana Angkut</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Cara Angkut<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionCaraAngkut}
                                        value={valueCaraAngkutOpt}
                                        getOptionValue={(option) => option.id}
                                        getOptionLabel={(option) => option.caraAngkut}
                                        additional={{
                                            page: 1,
                                        }}
                                        onChange={onChangeCaraAngkut}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.caraAngkut && <div className="text-danger">{kelengkapan.caraAngkut}</div>}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nama Angkut<span className="text-danger"> *</span></label>
                                    <input type="text" className="form-control-sm" name="nama_angkut" placeholder="Nama Angkut" onChange={onChangeNmAngkut} value={valueNmAngkut} readOnly={localStorage.getItem('isEditStorage') === '0' ? true : false} />
                                    {kelengkapan.nmAngkut && <div className="text-danger">{kelengkapan.nmAngkut}</div>}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nomor Voyage/Flight<span className="text-danger"> *</span></label>
                                    <input type="text" className="form-control-sm" name="novoy_flight" placeholder="Nomor Voyage / Flight" onChange={onChangeNoVoyFlight} value={valueNoVoyFlight} readOnly={localStorage.getItem('isEditStorage') === '0' ? true : false} />
                                    {kelengkapan.noVoyFlight && <div className="text-danger">{kelengkapan.noVoyFlight}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <label className="col-form-label-sm">Bendera<span className="text-danger"> *</span></label>
                                <AsyncPaginate
                                    loadOptions={loadOptionBendera}
                                    value={valueBenderaOpt}
                                    getOptionValue={(option) => option.kodeNegara}
                                    getOptionLabel={(option) => option.kodeNegara + ' - ' + option.uraianNegara}
                                    additional={{
                                        page: 1,
                                    }}
                                    onChange={onChangeBendera}
                                    isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                />
                                {kelengkapan.bendera && <div className="text-danger">{kelengkapan.bendera}</div>}
                            </div>
                            <div className="col-sm-6">
                                <label className="col-sm-6 col-form-label-sm">Tanggal Ekspor<span className="text-danger"> *</span></label>
                                <input type="date" className="col-sm-12 form-control-sm" name="tgl_ekspor" onChange={onChangeTglEkspor} value={valueTglEkspor} readOnly={localStorage.getItem('isEditStorage') === '0' ? true : false} />
                                {kelengkapan.tglEkspor && <div className="text-danger">{kelengkapan.tglEkspor}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Penerima</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nama<span className="text-danger"> *</span></label>
                                    <div className="col-12">
                                        {
                                            localStorage.getItem("kodeTrader") != null &&
                                            <AsyncPaginate
                                                loadOptions={loadOptionPartnerByTrader}
                                                value={valuePartnerOpt}
                                                getOptionValue={(option) => option.idPartner}
                                                getOptionLabel={(option) => option.noId + '-' + option.nama + '-' + option.alamat + '-' + option.negara}
                                                additional={{
                                                    page: 1
                                                }}
                                                onChange={onChangePartner}
                                                isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                            />
                                        }
                                        {
                                            localStorage.getItem("kodeTrader") == null &&
                                            <AsyncPaginate
                                                loadOptions={loadOptionPartner}
                                                value={valuePartnerOpt}
                                                getOptionValue={(option) => option.idPartner}
                                                getOptionLabel={(option) => option.nama}
                                                additional={{
                                                    page: 1
                                                }}
                                                onChange={onChangePartner}
                                                isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                            />
                                        }
                                        {kelengkapan.partner && <div className="text-danger">{kelengkapan.partner}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Alamat</label>
                                    <textarea rows={3} className="form-control" name="alamat_penerima" value={valuePartnerOpt !== null ? valuePartnerOpt.alamat : ''} readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <label className="col-form-label-sm">Negara Penerima</label>
                            <div className="col-6">
                                <input type="text" className="form-control-sm" name="nama_penerima" placeholder="Negara" value={valuePartnerOpt !== null ? valuePartnerOpt.negara : ''} readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Informasi Lain</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nilai Ekspor Total (Rp)<span className="text-danger"> *</span></label>
                                    <input type="text" className="form-control-sm" name="nilai_peb" placeholder="Nilai" onChange={onChangeNilai} value={valueNilaiEkspor} readOnly={localStorage.getItem('isEditStorage') === '0' ? true : false} />
                                    {kelengkapan.nilaiEkspor && <div className="text-danger">{kelengkapan.nilaiEkspor}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Bruto (kilogram) <span className="text-danger"> *</span></label>
                                    <input type="text" className="form-control-sm" name="bruto" placeholder="Bruto" onChange={onChangeBruto} value={valueBruto} readOnly={localStorage.getItem('isEditStorage') === '0' ? true : false} />
                                    {kelengkapan.bruto && <div className="text-danger">{kelengkapan.bruto}</div>}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Netto (kilogram) <span className="text-danger"> *</span></label>
                                    <input type="text" className="form-control-sm" name="netto" placeholder="Netto" onChange={onChangeNetto} value={valueNetto} readOnly={localStorage.getItem('isEditStorage') === '0' ? true : false} />
                                    {kelengkapan.netto && <div className="text-danger">{kelengkapan.netto}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Penanggungjawab Ekspor</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nama</label>
                                    <input type="text" className="form-control-sm" name="nama_pj" placeholder="Nama Penanggungjawab" value={valueNamaCp} readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Alamat</label>
                                    <textarea rows={3} className="form-control" name="alamat_pj" value={valueAlamatCp} readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nomor Telepon</label>
                                    <input type="text" className="form-control-sm" name="telp_pj" placeholder="Nomor Telepon" value={valueTelpCp} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Penandatangan Dokumen Permohonan</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nama TTD</label>
                                    <input type="text" className="form-control-sm" name="nama_ttd" placeholder="Nama Penandatangan" value={valueNamaTtd} onChange={onChangeNamaTtd} />
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Jabatan TTD</label>
                                    <input type="text" className="form-control-sm" name="jabatan_ttd" placeholder="Jabatan Penandatangan" value={valueJabatanTtd} onChange={onChangeJabatanTtd} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Tempat TTD<span className="text-danger"> *</span></label>
                                    <input type="text" className="form-control-sm" name="tempat_ttd" placeholder="Tempat" value={valueTempatTtd} onChange={onChangeTempatTtd} />
                                    {kelengkapan.tempatTtd && <div className="text-danger">{kelengkapan.tempatTtd}</div>}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Tanggal TTD</label>
                                    <input type="date" className="form-control-sm" name="tanggal_ttd" value={valueTanggalTtd} onChange={onChangeTanggalTtd} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    localStorage.getItem('isEditStorage') === '1' ? <>
                        <button type="button" name="next" className="btn btn-primary next action-button float-end btn-sm" value="Next" onClick={handleShowConfirmSave} ><FaSave /> Simpan & Lanjutkan</button>
                        <button type="button" name="back" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Kembali" onClick={() => cancelHeader()} ><FaChevronLeft /> Batal</button>
                    </> : ''
                }
            </div>
            {
                showConfirmSave &&
                <SweetAlert
                    title="Simpan Data Entitas?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Entitas Berhasil"
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Entitas Gagal"
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ViewHeader